module.exports = __webpack_public_path__ + "img/8.2941879d.jpg";